import { Updater, AsyncState, loadedAsyncState, loadingAsyncState } from "widgets-for-react";
import { courseSearch } from "../cmsPage/sharepointPageApi/sharepointPageApi";
import { CoursePageData, PageResult } from "../cmsPage/sharepointPageApi/types/pageData";

export type CourseSearchResult = PageResult<CoursePageData>

export interface CourseSearchState {
    query?: string
    page?: number
    result: AsyncState<CourseSearchResult>
}

export const initialCourseSearchState: (query?: string, page?: string) => CourseSearchState = 
(query, page) => {
    const intPage = parseInt((page || '1'));
    return {
        result: query
            ? loadingAsyncState(() => courseSearch(query || '', intPage))
            : loadedAsyncState<PageResult<CoursePageData>>({ Count: 0, PerPage: 10, Total: 0, Resources: [] }),
        query: query || '',
        page: intPage
    };
}

export const courseSearchPageStateUpdaters = {
    updateSearchResult: (updater: Updater<AsyncState<CourseSearchResult>>) =>
        (state: CourseSearchState): CourseSearchState => ({
            ...state,
            result: updater(state.result),
        }),
}